import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

import { localeWithMandatoryConsent } from '@/pages/diagnostic/components/PatientConsentDialog'
import { isStaff } from '@/utils/type-guards'

type UsePatientConsentDialogParams = {
  newlyCreatedConsultationId?: string
}

export function usePatientConsentDialog({ newlyCreatedConsultationId }: UsePatientConsentDialogParams) {
  const navigate = useNavigate()
  const authUser = useAppSelector(selectAuthUser)

  const [isConsentDialogOpen, setConsentDialogOpen] = useState(false)

  const handleConsentResponse = useCallback(
    (accepted?: boolean) => {
      if (!accepted) {
        navigate('/')
      }
      setConsentDialogOpen(false)
    },
    [navigate]
  )

  useEffect(() => {
    if (
      newlyCreatedConsultationId &&
      authUser &&
      isStaff(authUser) &&
      authUser.status === 'PDS' &&
      authUser?.userInfo?.language &&
      localeWithMandatoryConsent.includes(authUser?.userInfo?.language)
    ) {
      setConsentDialogOpen(true)
    }
  }, [newlyCreatedConsultationId, authUser])

  const shouldShowConsentDialog = authUser && isStaff(authUser) && authUser.status === 'PDS'
  const showTreatingPhysician = authUser && isStaff(authUser) ? authUser.userInfo.language !== 'it' : true

  return {
    handleConsentResponse,
    isConsentDialogOpen,
    shouldShowConsentDialog,
    showTreatingPhysician,
  }
}
